import { useEffect, useState } from "react";
import config from "../../config";

function StockModel({ showModal, closeModal, onSave, selectedStock }) {

    const [categories, setCategories] = useState([]);
    const [productSearch, setProductSearch] = useState('');
    const [supplierSearch, setSupplierSearch] = useState('');

    const [productSuggestions, setProductSuggestions] = useState([]);
    const [supplierSuggestions, setSupplierSuggestions] = useState([]);

    const [error, setError] = useState(null);

    const [formData, setFormData] = useState({
        stockName: '',
        supplierName: '',
        stockDate: '',
        description: '',
        prodName: '',
        category: '',
        unitPrice: '',
        qyt: '',
        totalPrice: '',

        supplierSearch: '',
        productSearch: '',
    });

    useEffect(() => {
        fetchCategories();
    }, [])

    useEffect(() => {
        if (selectedStock) {
            let formattedDate = '';
            if (selectedStock.stockDate) {
                const stockDate = new Date(selectedStock.stockDate);
                formattedDate = `${stockDate.getFullYear()}-${String(stockDate.getMonth() + 1).padStart(2, '0')}-${String(stockDate.getDate()).padStart(2, '0')} ${String(stockDate.getHours()).padStart(2, '0')}:${String(stockDate.getMinutes()).padStart(2, '0')}`;
            }

            setFormData({
                stockName: selectedStock.stockName || '',
                supplier: selectedStock.supplier?.supplierId || '',
                stockDate: formattedDate,
                description: selectedStock.stockDescription || '',
                product: selectedStock.product?.productId || '',
                category: selectedStock.category || '',
                unitPrice: selectedStock.unitPrice || '',
                qyt: selectedStock.stockQty || '',
                totalPrice: selectedStock.stockPrice || '',
            });

            setProductSearch(selectedStock.product?.productName || '');
            setSupplierSearch(selectedStock.supplier?.supplierName || '');
        }
    }, [selectedStock]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));

        if (name === 'unitPrice' || name === 'qyt') {
            const unitPrice = name === 'unitPrice' ? parseFloat(value) || 0 : parseFloat(formData.unitPrice) || 0;
            const quantity = name === 'qyt' ? parseFloat(value) || 0 : parseFloat(formData.qyt) || 0;
            const total = unitPrice * quantity;
            setFormData(prevData => ({
                ...prevData,
                totalPrice: total.toFixed(2)
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const stockId = selectedStock.stockId;
            const updatedStockData = {
                stockName: formData.stockName,
                stockDate: formData.stockDate,
                stockDescription: formData.description,
                unitPrice: parseFloat(formData.unitPrice),
                stockQty: parseInt(formData.qyt),
                stockPrice: parseFloat(formData.totalPrice),
                productId: formData.product,
                supplierId: formData.supplier,
                categoryId: formData.categoryName
            };

            const response = await fetch(`${config.BASE_URL}/stock/${stockId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedStockData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`Failed to update stock: ${response.status} ${response.statusText}. ${errorData.message || ''}`);
            }

            closeModal();
            if (onSave) onSave();

        } catch (err) {
            setError(`Error updating stock: ${err.message}`);
        }
    };

    const fetchCategories = async () => {
        try {
            const response = await fetch(`${config.BASE_URL}/categories`);
            if (response.ok) {
                const data = await response.json();
                setCategories(data);
            } else {
                console.error('Failed to fetch categories');
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    //supplier search
    const handleSupplierSearch = async (e) => {
        const query = e.target.value;
        setSupplierSearch(query);

        if (query.length >= 2) {
            try {
                const response = await fetch(`${config.BASE_URL}/suppliers/suggestions?query=${query}`);
                if (response.ok) {
                    const suggestions = await response.json();
                    setSupplierSuggestions(suggestions);
                } else {
                    console.error('Failed to fetch supplier suggestions');
                }
            } catch (error) {
                console.error('Error fetching supplier suggestions:', error);
            }
        } else {
            setSupplierSuggestions([]);
        }
    };

    //supplier select
    const handleSupplierSelect = async (supplierName) => {
        setSupplierSearch(supplierName);
        setSupplierSuggestions([]);

        try {
            const response = await fetch(`${config.BASE_URL}/supplier/supplierName/${supplierName}`);
            if (response.ok) {
                const supplier = await response.json();
                setFormData(prevData => ({
                    ...prevData,
                    supplier: supplier.supplierId,
                    supplierName: supplier.supplierName,
                }));
            } else {
                console.error('Product not found');
            }
        } catch (error) {
            console.error('Error fetching product details:', error);
        }
    };

    //product search
    const handleProductSearch = async (e) => {
        const query = e.target.value;
        setProductSearch(query);

        if (query.length >= 2) {
            try {
                const response = await fetch(`${config.BASE_URL}/products/suggestions?query=${query}`);
                if (response.ok) {
                    const suggestions = await response.json();
                    setProductSuggestions(suggestions);
                } else {
                    console.error('Failed to fetch product suggestions');
                }
            } catch (error) {
                console.error('Error fetching product suggestions:', error);
            }
        } else {
            setProductSuggestions([]);
        }
    };

    //product select
    const handleProductSelect = async (productName) => {
        setProductSearch(productName);
        setProductSuggestions([]);

        try {
            const response = await fetch(`${config.BASE_URL}/product/productName/${productName}`);
            if (response.ok) {
                const product = await response.json();
                setFormData(prevData => ({
                    ...prevData,
                    product: product.productId,
                    category: product.categoryId,
                }));
            } else {
                console.error('Product not found');
            }
        } catch (error) {
            console.error('Error fetching product details:', error);
        }
    };

    if (!showModal) return null;

    return (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center", alignItems: "flex-start", paddingTop: "5%", zIndex: 1000, }}>
            <div className="p-3" style={{ position: "relative", background: "#ffffff", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", width: "50%", maxHeight: "85%", padding: "20px", overflowY: "auto", }}>
                {error && <div className="error-message" style={{ color: 'red' }}>{error}</div>}

                <h4 className="mt-3">Stock Update</h4>

                <form onSubmit={handleSubmit} className="mt-4">

                    <div className="row mb-3">

                        <div className="col-md-6">
                            <label htmlFor="stockName">Stock Name / Batch No</label>
                            <input
                                type="text"
                                className="form-control"
                                id="stockName"
                                name="stockName"
                                value={formData.stockName}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className="col-md-6">
                            <label htmlFor="supplier">Supplier Name</label>
                            <input
                                type="text"
                                name="supplierSearch"
                                className="form-control"
                                value={supplierSearch}
                                onChange={handleSupplierSearch}
                                required
                            />
                            {supplierSuggestions.length > 0 && (
                                <ul className="list-group mt-0">
                                    {supplierSuggestions.map((supplier, index) => (
                                        <li
                                            key={index}
                                            className="list-group-item list-group-item-action"
                                            onClick={() => handleSupplierSelect(supplier.supplierName)}
                                        >
                                            {supplier.supplierName}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label htmlFor="stockDate">Purchase Date</label>
                            <input type="datetime-local" className="form-control" id="stockDate" name="stockDate" value={formData.stockDate} onChange={handleInputChange} />
                        </div>

                        <div className="col-md-6">
                            <label htmlFor="description">Description</label>
                            <input
                                type="text"
                                className="form-control"
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label htmlFor="productSearch">Product Name</label>
                            <input
                                type="text"
                                name="productSearch"
                                className="form-control"
                                value={productSearch}
                                onChange={handleProductSearch}
                                required
                            />
                            {productSuggestions.length > 0 && (
                                <ul className="list-group mt-0">
                                    {productSuggestions.map((product, index) => (
                                        <li
                                            key={index}
                                            className="list-group-item list-group-item-action"
                                            onClick={() => handleProductSelect(product.productName)}
                                        >
                                            {product.productName}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label htmlFor="category">Product Category</label>
                            <input
                                type="text"
                                name="category"
                                value={categories.find(c => c.categoryId === formData.category)?.categoryName || 'Unknown'}
                                className="form-control"
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label htmlFor="unitPrice">Unit Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="unitPrice"
                                name="unitPrice"
                                value={formData.unitPrice}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="qyt">Quantity</label>
                            <input
                                type="text"
                                className="form-control"
                                id="qyt"
                                name="qyt"
                                value={formData.qyt}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="totalPrice">Total Price</label>
                            <input
                                type="text"
                                className="form-control"
                                id="totalPrice"
                                name="totalPrice"
                                value={formData.totalPrice}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="modal-footer d-flex">
                        <button type="button" className="btn btn-danger" onClick={closeModal}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-warning">
                            Update
                        </button>
                    </div>

                </form>
            </div>
        </div>
    )
}

export default StockModel